import { z } from 'zod';

// A corporate group and its companies alone, for whoever never shows its travelers.
export const CorporateGroupCompaniesViewSchema = z.object({
  id: z.string().min(1),
  name: z.string(),
  companies: z.array(
    z.object({ id: z.string(), name: z.string(), isMice: z.boolean().optional() }),
  ),
});
export type CorporateGroupCompaniesView = z.infer<typeof CorporateGroupCompaniesViewSchema>;

// A corporate group as the integrations console sees it: the unit a chat tool
// (Teams/Slack) is linked to. `emailDomains` are the distinct e-mail domains of
// its travelers — what a connected tenant must share to be the right company.
export const CorporateGroupViewSchema = CorporateGroupCompaniesViewSchema.extend({
  travelerCount: z.number().int().nonnegative(),
  emailDomains: z.array(z.string()),
});
export type CorporateGroupView = z.infer<typeof CorporateGroupViewSchema>;

// `companies` skips the traveler count and domains: they read every traveler of the group.
export const CorporateGroupsViewSchema = z.enum(['full', 'companies']);
